export default {
  normal: {
    name: 'normal',
  },
  accent: {
    name: 'accent',
  },
  brand: {
    name: 'brand',
  },
  positive: {
    name: 'positive',
  },
  negative: {
    name: 'negative',
  },
};
